/** Inline SVG glyphs (12x12 viewBox) for each priority level. */

import type { PriorityLevel } from './priority.js';

interface GlyphProps {
    className?: string;
}

export function NormalGlyph({ className }: GlyphProps) {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M3 6 L9 6" stroke="currentColor" />
        </svg>
    );
}

export function HighGlyph({ className }: GlyphProps) {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M2.5 7.5 L6 4 L9.5 7.5" stroke="currentColor" />
        </svg>
    );
}

export function ExtremeGlyph({ className }: GlyphProps) {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M2.5 6.5 L6 3 L9.5 6.5" stroke="currentColor" />
            <path d="M2.5 10 L6 6.5 L9.5 10" stroke="currentColor" />
        </svg>
    );
}

// Each level's glyph in its own tone, for borderless surfaces such as menu rows.
export function PriorityGlyph({ priority }: { priority: PriorityLevel }) {
    if (priority === 'high') {
        return <HighGlyph className="text-amber-600" />;
    }
    if (priority === 'extreme') {
        return <ExtremeGlyph className="text-red-600" />;
    }
    return <NormalGlyph className="text-gray-400" />;
}
